<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form
        ref="infoForm"
        label-width="100px"
        class="info-form"
        style="margin-top: 22px"
      >
        <el-form-item label="会员名称">
          <el-input
            size="small"
            placeholder="请输入会员名称"
            v-model="detail.name"
            disabled
            style="width: 232px"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效期">
          <div style="display: flex">
            <div>
              <el-select
                size="small"
                v-model="detail.expirationDate"
                style="width: 232px"
                placeholder="请选择有效期"
                disabled
              >
                <el-option
                  v-for="item in expireDates"
                  :key="item.dictId"
                  :label="item.dictName"
                  :value="item.dictId"
                >
                </el-option>
              </el-select>
            </div>
            <div style="margin-left: 32px">购买价格</div>
            <div style="margin-left: 16px">
              <el-input
                style="width: 116px"
                v-model="detail.price"
                disabled
                size="small"
              >
                <div slot="suffix" style="margin-right: 8px">元</div></el-input
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="会员介绍页">
          <div class="detail" v-html="detail.introduce"></div>
        </el-form-item>
        <el-form-item label="会员状态">
          <div style="display: flex">
            <div :class="detail.status == 1 ? 'start' : 'end'"></div>
            <div class="s-label" v-if="detail.status == 1">已启用</div>
            <div class="s-label" v-else>已禁用</div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="back-btn">
      <el-button type="info" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
  },
  data () {
    return {
      expireDates: [
        {
          dictId: 1,
          dictName: '一个月'
        },
        {
          dictId: 3,
          dictName: '三个月'
        },
        {
          dictId: 12,
          dictName: '一年'
        },
        {
          dictId: 0,
          dictName: '永久'
        },
      ],
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '会员管理', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '查看会员', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      arr: []
    }
  },
  created () {
    this.getDetail()
  },

  methods: {
    back () {
      this.$router.go(-1)
    },
    select () {
      console.log(this.arr)
    },
    getDetail () {
      this.axios.get('users/membersInfo?id=' + this.$route.query.id)
        .then(res => {
          if (res.code == 0) {
            res.data.price = res.data.price.toFixed(2)
            this.detail = res.data
            this.$forceUpdate()
          }
        })
    },
    handleCurrentChange () {

    },
    handleSizeChange () {

    },
    handleSelectionChange () {

    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ebeefa;
  border-color: #c0c0cc;
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left !important;
}
.detail {
  width: 990px;
  min-height: 280px;
  background: #ebeefa;
  opacity: 1;
  border-radius: 3px;
  padding: 10px 10px;
  color: #303033;
}
.s-label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  opacity: 1;
}
.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;
  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

